import React from "react";
import classNames from "./style.module.scss";
import Conditional from "../../common/conditional";

interface ConfirmProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

const Confirm: React.FC<ConfirmProps> = (props) => {
  return (
    <div className={classNames["confirm"]}>
      <h2>
        <i className='bi bi-info-circle'></i>
        <span>{props.title}</span>
      </h2>

      <p>{props.message}</p>

      <div className={classNames["confirm-actions"]}>
        <button
          type='button'
          className={classNames["confirm-actions-no"]}
          onClick={props.onConfirm}
        > 
          Yes, confirm
        </button>

       <Conditional isVisible={props.onCancel !== undefined}>
            <button
              type='button'
              className={classNames["confirm-actions-yes"]}
              onClick={props.onCancel}
            >
              No
            </button>
       </Conditional>
      </div>
    </div>
  );
};

export default Confirm;
